TestModel.$inject = ["ApiHttp", "$modelFactory"];function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}export var testDefaults = {
  foo: "",
  bar: 0,
  customerId: 0,
  id: 0 };


export function TestModel(ApiHttp, $modelFactory) {
  "ngInject";

  // return $modelFactory(ApiHttp.customerOrder, {
  return $modelFactory("api/v1/customers/{customerId}/orders", {
    defaults: testDefaults,

    map: {},

    prefix: '',
    pk: 'id',
    stripTrailingSlashes: true,

    actions: {
      'base': {
        beforeRequest: function beforeRequest() {/*...*/},
        afterRequest: function afterRequest() {/*...*/}
        // override: true
      },
      'query': {
        // lets cache all query requests
        // this uses the out of the box angular caching
        // for $http.  I create a cache factory on each
        // instance so you can access it via `$cache` attribute
        cache: true,
        withCredentials: true,
        params: { foo: 123, bar: 456 } },

      'get': {
        params: { customerId: 123, id: 456 } },

      'post': _defineProperty({
        params: {
          params: true, foo: 123 },

        body: { data: { data: true, foo: 123 } } }, "body",
      { body: { data: true, foo: 123 } }),

      'put': {},
      'delete': {} },


    instance: {
      instanceMethod: function instanceMethod() {
        console.log('instance', this, this.$save);
      } },


    list: {
      listMethod: function listMethod() {
        console.log('list', this, this);
      } },


    getCuctom: function getCuctom() {
      return this.get({}).
      then(function (res) {console.warn('res', res);return res;}).
      catch(function (res) {console.warn('err', res);throw res;});
    } });




}